import { OrderUrlConstant } from 'src/constants';
import {
  CancelOrderDto,
  CreateOrderDto,
  GetOrderDto,
  GetOrderListDto,
  GetOrderListResponseDto,
  OrderDto,
} from 'src/dtos';
import { ConfigService } from 'src/services';
import { replacePlaceholders, httpRequest } from 'src/utils';

export class OrdersApi {
  private _configService: ConfigService;
  constructor(configService: ConfigService) {
    this._configService = configService;
  }

  async create({ params, body }: CreateOrderDto): Promise<OrderDto> {
    const { accountId } = params;
    const url = replacePlaceholders(OrderUrlConstant.CREATE, { accountId });

    return httpRequest<OrderDto>({
      method: 'POST',
      url,
      body,
      authToken: this._configService.authToken,
    });
  }

  async list({ params, queryParams }: GetOrderListDto): Promise<GetOrderListResponseDto> {
    const { accountId } = params;

    const url = replacePlaceholders(OrderUrlConstant.LIST, { accountId });

    return httpRequest<GetOrderListResponseDto>({
      method: 'GET',
      url,
      queryParams,
      authToken: this._configService.authToken,
    });
  }

  async retrieve({ params }: GetOrderDto): Promise<OrderDto> {
    const { id, accountId } = params;

    const url = replacePlaceholders(OrderUrlConstant.RETRIEVE, { id, accountId });

    return httpRequest<OrderDto>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
    });
  }

  async cancel({ params }: CancelOrderDto): Promise<void> {
    const { accountId, id } = params;

    const url = replacePlaceholders(OrderUrlConstant.CANCEL, { id, accountId });

    return httpRequest<void>({
      method: 'PUT',
      url,
      authToken: this._configService.authToken,
    });
  }
}
